export default "__VITE_ASSET__B$CHaYFq__"